"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateIntakeCandidateSchema = exports.createIntakeCandidateSchema = exports.intakeCandidateSchema = exports.IntakeCandidateStatusLabels = exports.IntakeCandidateStatuses = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
const localDate_js_1 = require("../localDate.js");
exports.IntakeCandidateStatuses = [
    'NEW',
    'CONTACTED',
    'SCHEDULED',
    'CONVERTED',
    'DECLINED',
    'DUPLICATE',
];
exports.IntakeCandidateStatusLabels = {
    NEW: 'New',
    CONTACTED: 'Contacted',
    SCHEDULED: 'Scheduled',
    CONVERTED: 'Converted',
    DECLINED: 'Declined',
    DUPLICATE: 'Duplicate',
};
exports.intakeCandidateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    // EMR client ID — optional. Housing-sourced candidates won't have one
    // until the operator fills it in at intake time.
    externalRef: zod_1.z.string().nullable().optional(),
    // Synthetic key for housing-promoted rows: "housing:<location>:<rowKey>".
    housingSourceRef: zod_1.z.string().nullable().optional(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    email: zod_1.z.string().email().nullable().optional(),
    cellPhone: zod_1.z.string().nullable().optional(),
    dob: localDate_js_1.localDateSchema.nullable().optional(),
    suggestedCohort: zod_1.z.enum(enums_js_1.CohortLetters).nullable().optional(),
    presentingConcerns: zod_1.z.string().nullable().optional(),
    emrNotes: zod_1.z.string().nullable().optional(),
    sourceLabel: zod_1.z.string().nullable().optional(),
    status: zod_1.z.enum(exports.IntakeCandidateStatuses),
    clientId: zod_1.z.string().uuid().nullable().optional(),
    archivedAt: zod_1.z.string().datetime().nullable().optional(),
    notes: zod_1.z.string().nullable().optional(),
    receivedAt: zod_1.z.string().datetime(),
    convertedAt: zod_1.z.string().datetime().nullable().optional(),
});
// EMR-facing POST body. externalRef + firstName + lastName are required;
// everything else optional.
exports.createIntakeCandidateSchema = zod_1.z.object({
    externalRef: zod_1.z.string().min(1),
    firstName: zod_1.z.string().min(1),
    lastName: zod_1.z.string().min(1),
    email: zod_1.z.string().email().optional(),
    cellPhone: zod_1.z.string().optional(),
    dob: localDate_js_1.localDateSchema.optional(),
    suggestedCohort: zod_1.z.enum(enums_js_1.CohortLetters).optional(),
    presentingConcerns: zod_1.z.string().optional(),
    emrNotes: zod_1.z.string().optional(),
    sourceLabel: zod_1.z.string().optional(),
});
exports.updateIntakeCandidateSchema = zod_1.z.object({
    status: zod_1.z.enum(exports.IntakeCandidateStatuses).optional(),
    notes: zod_1.z.string().nullable().optional(),
    cellPhone: zod_1.z.string().nullable().optional(),
    email: zod_1.z.string().email().nullable().optional(),
    archived: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=intake-candidate.js.map